import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { UtilService } from 'src/app/shared/services';

@Component({
  selector: 'app-copyright-footer',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule
  ],
  templateUrl: './copyright-footer.component.html',
  styleUrls: ['./copyright-footer.component.scss']
})
export class CopyrightFooterComponent {
  constructor(
    public util: UtilService
  ) {}

  footerContent = [
    { id: 1, isLink: false, icon: 'location_on', content: 'Child Help Foundation, 403/404, Sai Arpan, Near P.G.Vora school, Mira Road East, Thane - 401107' },
    { id: 3, isLink: true, icon: 'mail', content: 'mumbaiteam@childhelpfoundationindia.org' },
    { id: 2, isLink: true, icon: 'call', content: '02248970898' },
  ]
}
